import React from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import TrashIcon from "@material-ui/icons/Delete";
import RemoveIcon from "@material-ui/icons/Remove";
import { useDispatch, useSelector } from "react-redux";
import { cartAction } from "../state/actions";
import { useParams } from "react-router-dom";
import { SellingAreaStatus } from "../state";

const useStyles = makeStyles((theme: Theme) => ({
	cardActions: {
		display: "flex",
		flexDirection: "row",
		padding: theme.spacing(0),
		alignItems: "center",
		justifyContent: "flex-start",
		position: "relative",
	},
	right: {
		flex: 1,
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		padding: theme.spacing(1),
		marginLeft: "70px",
	},
	title: {
		fontSize: "14px",
	},
	title_label: {
		fontWeight: "bold",
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		fontSize: "14px",
		lineHeight: "normal",
	},
	iconButton: {
		"color": "white",
		"backgroundColor": theme.palette.primary.main,
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
	},
	quantity: {
		padding: theme.spacing(0, 1),
	},
	card: {
		margin: theme.spacing(1, 0, 0),
	},
	editItem: {
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "space-between",
	},
	removeItem: {
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "center",
	},
	image: {
		height: "100px",
		aspectRatio: "1/1",
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center center",
		borderRadius: "200px",
		position: "absolute",
		left: "-30px",
	},
	info: {
		flexGrow: 0,
		flexShrink: 1,
	},
	actions: {
		display: "flex",
		flexDirection: "row",
		gap: "15px",
	},
}));

export default function ProductCardCartV2(props) {
	const classes = useStyles();
	let params = useParams();
	let id = params["id"];
	const wallet = useSelector((state) => state.wallet);
	const corporateCredit = useSelector((state) => state.corporateCredit);
	const sellingAreaStatus = useSelector((state) => state.status);
	const catalog = useSelector((state) => state.catalog);
	const catalogItem = catalog?.itemsRaw?.find(
		(item) => item.id === props.item.itemSaleableId
	);
	const dispatch = useDispatch();

	return (
		<Card className={classes.card}>
			<CardActions disableSpacing={true} className={classes.cardActions}>
				<div
					className={classes.image}
					style={{ backgroundImage: `url(${props.item.photoUrl})` }}
				></div>
				<div className={classes.right}>
					<div className={classes.info}>
						<Typography
							variant="subtitle1"
							color="textPrimary"
							className={classes.title_label}
						>
							{props.item.label}
						</Typography>
						<Typography
							className={classes.title}
							variant="subtitle1"
							color="textPrimary"
						>
							{`${parseFloat(
								(
									props.item.unitPriceWithTax *
									props.item.quantity
								).toFixed(2)
							)} €`}
						</Typography>
					</div>
					<div className={classes.actions}>
						<div className={classes.editItem}>
							<IconButton
								disabled={
									sellingAreaStatus ===
									SellingAreaStatus.FETCHING_DATA
								}
								color="primary"
								size="small"
								onClick={() => {
									cartAction.updateCartItem(dispatch, {
										lockerId: id,
										itemSaleableId:
											props.item.itemSaleableId,
										quantity: props.item.quantity - 1,
										localPrice: props.item.unitPriceWithTax,
										localLabel: props.item.label,
										availableQuantity:
											props.item.availableQuantity,
										walletBalance: wallet?.balance || 0,
										corporateCreditBalance:
											corporateCredit?.balance || 0,
									});
								}}
								className={classes.iconButton}
							>
								<RemoveIcon fontSize="small" />
							</IconButton>
							<Typography
								className={classes.quantity}
								variant="subtitle1"
								color="textPrimary"
							>
								{props.item.quantity}
							</Typography>
							<IconButton
								disabled={
									sellingAreaStatus ===
									SellingAreaStatus.FETCHING_DATA
								}
								color="primary"
								size="small"
								onClick={() => {
									cartAction.updateCartItem(dispatch, {
										lockerId: id,
										itemSaleableId:
											props.item.itemSaleableId,
										quantity: props.item.quantity + 1,
										localPrice: props.item.unitPriceWithTax,
										localLabel: props.item.label,
										availableQuantity:
											props.item.availableQuantity ||
											catalogItem?.availableQuantity,
										walletBalance: wallet?.balance || 0,
										corporateCreditBalance:
											corporateCredit?.balance || 0,
									});
								}}
								className={classes.iconButton}
							>
								<AddIcon fontSize="small" />
							</IconButton>
						</div>
						<div className={classes.removeItem}>
							<IconButton
								disabled={
									sellingAreaStatus ===
									SellingAreaStatus.FETCHING_DATA
								}
								onClick={() => {
									cartAction.updateCartItem(dispatch, {
										lockerId: id,
										itemSaleableId:
											props.item.itemSaleableId,
										quantity: 0,
										localPrice: props.item.unitPriceWithTax,
										localLabel: props.item.label,
										availableQuantity:
											props.item.availableQuantity ||
											catalogItem?.availableQuantity,
										walletBalance: wallet?.balance || 0,
										corporateCreditBalance:
											corporateCredit?.balance || 0,
									});
								}}
								style={{ opacity: "70%" }}
								size="small"
							>
								<TrashIcon fontSize="small" />
							</IconButton>
						</div>
					</div>
				</div>
			</CardActions>
		</Card>
	);
}
